import React, { useState, useCallback } from "react";
import "./searchBar.css";
import SearchIcon from "@material-ui/icons/Search";
import PredictionBox from "../predictionBox/PredictionBox";
import { debounce } from "lodash";
import axios from "axios";
import API_ENDPOINT from "../wm.api.service";
import { CircularProgress } from "@material-ui/core";
import { connect } from "react-redux";

function SearchBar({ rootData }) {
  const queryString = window.location.search;
  const parameter = new URLSearchParams(queryString);
  const value = parameter.get("search_query");
  const [open, setIsOpen] = useState(true);
  const [searchWord, setSearchWord] = useState(value ? value : '');
  const [searchData, setSearchData] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const debounceFn = useCallback(debounce(handleDebounceFn, 500), []);
  const searchResult = (e) => {
    setSearchWord(e.target.value);
    debounceFn(e.target.value);
  };
  function handleDebounceFn(inputValue) {
    if (inputValue.length > 0) {
      setIsSearching(true);
      var fd = new FormData();
      fd.append("search_key", inputValue);
      axios({
        url: `${API_ENDPOINT.apiURL}Profile/search`,
        method: "POST",
        data: fd,
      })
        .then(function (response) {
          setIsSearching(false);
          setSearchData(response.data);
          openSearchBox();
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }
  const openSearchBox = () => {
    setIsOpen(false);
    document.getElementById("navSearch").classList.add("searchBox--backdrop");
    document.body.style.overflow = "hidden";
  };
  const closeSearchBox = () => {
    setIsOpen(true);
    document
      .getElementById("navSearch")
      .classList.remove("searchBox--backdrop");
    document.body.style.overflow = "";
  };
  return (
    <React.Fragment>
      <div className="searchBarWrapper flex w-100 relative items-center rounded-md ">
        <SearchIcon className="search_ico" />
        <input
          type="text"
          placeholder="Search for anything..."
          className="seachInput"
          autoComplete="off"
          id="mainSearchBar"
          value={searchWord}
          onChange={(e) => searchResult(e)}
          onKeyPress={(e) => e.key === "Enter" && window.location.assign(`${API_ENDPOINT.redirectURL}/s/search?search_query=${searchWord}`)}
        />
        {isSearching && <CircularProgress size={20} />}
      </div>
      <PredictionBox
        hidden={open}
        searchQuery={searchWord}
        close={() => closeSearchBox()}
        searchedData={searchData}
      />
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return state;
};

export default connect(mapStateToProps, null)(SearchBar);
